
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/leadership-team",
      function () {
        return require("private-next-pages/about-us/leadership-team/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/leadership-team"])
      });
    }
  